import { Component, Input, OnChanges, OnInit, SimpleChange, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ContactDialogComponent } from 'src/app/pages/contact-dialog/contact-dialog.component';
import { CommonServiceService } from 'src/app/pages/services/common-service.service';

@Component({
  selector: 'app-compose-message',
  templateUrl: './compose-message.component.html',
  styleUrls: ['./compose-message.component.scss']
})
export class ComposeMessageComponent implements OnInit, OnChanges {

  selectedIndex = 1;
  payloadFilters: any = '';
  dialogRef: any;
  public limit = 10;
  public skip = 0;
  public page: any = 1;
  allResponseData: any = [];
  totalDataCount = 0;
  searchedValue = '';
  tableHead: any = [{thead : 'S.No.'}, {thead : 'Admins', key: 'admin'}, {thead : 'Contact'}];
  sortSelection = '';
  selectedColumn = '';
  selectedTab: any = 'none';
  currentSeletedSubTab = '';
  tokenCheck: string | null;
  orderSorting = '';
  labelName = 'Admin';
  @Input() selectedMatIndex = 0;
  userData: any = JSON.parse(sessionStorage.getItem('userdata') || '{}');


  constructor(private commonService: CommonServiceService, private snackBar: MatSnackBar, public dialog: MatDialog,
              private formBuilder: FormBuilder) {
    this.tokenCheck = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '';

     }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes?.selectedMatIndex && changes?.selectedMatIndex?.currentValue){
    this.selectedIndex = 0;
    this.getAdmin(1);
    }
  }

  commonSwitch(labelName: any, searchedValue: any = ''): void {
    switch (labelName) {
      case 'Admin':
        this.tableHead = [{thead : 'S.No.'}, {thead : 'Admins', key: 'admin'}, {thead : 'Contact'}];
        this.getAdmin(this.page, searchedValue, '', this.orderSorting, this.selectedColumn);
        break;
      case 'MSME':
        this.tableHead = [{thead : 'S.No.'}, {thead : 'MSME', key: 'msme'}, {thead : 'Contact'}];
        this.getAdmin(this.page, searchedValue, '', this.orderSorting, this.selectedColumn);
        break;
      default:
        break;
    }
  }

  tabWiseData(event: any): void {
    this.selectedIndex = event?.index;
    this.labelName = event?.tab?.textLabel;
    this.orderSorting = '';
    this.searchedValue = '';
    this.selectedColumn = '';
    this.commonSwitch(this.labelName);
  }

  openSnackBar(message: any, action = '', className= 'parmary'): void {
    this.snackBar.open(message, action, {
    duration: 3000,
  });
  }

  openContactDialog(item: any): void {

    this.dialogRef =  this.dialog.open(ContactDialogComponent, {
      width: '500px',
      panelClass: 'contactDialog',
      data: {
        id: item.id ? item.id : 1,
        lineItemName: item.name,
        formType: this.labelName
      },
    });

    this.dialogRef.afterClosed().subscribe((confirmed: boolean) => {
    });
  }

  sortTable(columnName: string, sortType: string = ''): void {
    this.sortSelection = sortType;
    this.selectedColumn = columnName;
    this.orderSorting = sortType === 'down' ? 'DESC' : 'ASC';
    this.commonSwitch(this.labelName);
  }

  onKeyDownEvent(): void {
    if (this.searchedValue){
      this.commonSwitch(this.labelName, this.searchedValue);
    }else{
      this.openSnackBar(['Please enter any value']);
    }
  }

  clearSearch(): void {
    this.searchedValue = '';
    switch (this.labelName) {
      case 'Admin':
        this.tableHead = [{thead : 'S.No.'}, {thead : 'Admins', key: 'admin'}, {thead : 'Contact'}];
        this.getAdmin(this.page, '', '', this.orderSorting, this.selectedColumn);
        break;
      case 'MSME':
        this.tableHead = [{thead : 'S.No.'}, {thead : 'MSME', key: 'msme'}, {thead : 'Contact'}];
        this.getMsmelist(this.page, '', '', this.orderSorting, this.selectedColumn);
        break;
      default:
        break;
    }

  }



  setPage(event: any): void {
    this.page = event.pageIndex + 1;
    this.skip = (event.pageIndex + 1) * this.limit - this.limit;
    this.limit = event.pageSize;
    this.commonSwitch(this.labelName);
  }

  getAdmin(page: any, searchedValue: string = '', id: any = '', sortingOrder: string= '', culomnName: string= ''): void {
    this.commonService.allAdminMenbers(this.labelName, page, searchedValue, id, sortingOrder, culomnName).subscribe((res: any) => {
      if (res?.success){
        this.allResponseData = res.data.filter((ele: any) => ele.id !== this.userData?.id);
        this.totalDataCount = res.total;
      }
    }, error => {
      this.allResponseData = [];
    }
    );
  }


  getMsmelist(page: any, searchedValue: string = '', id: any = '', sortingOrder: string= '', culomnName: string= ''): void {
    id = this.payloadFilters?.countryId?.length ? this.payloadFilters.countryId.join(',') : '';
    this.commonService.msmeDashboardDetails(page, searchedValue, id, sortingOrder, culomnName).subscribe((res: any) => {
      if (res.success){
        this.allResponseData = res.data;
        this.totalDataCount = res.total;
      }
    }, error => {
      this.allResponseData = [];
    }
    );
  }
}
